<template>
  <div>
    <!--头部-->
    <el-row >
      <el-col :span="4"><div class="grid_content"></div></el-col>
      <el-col :span="7">
        <div class="grid_content">
          <div class='logo' >
            <img src="../../assets/images/logo.png" alt="logo" @click='skipHome()'/>
          </div>
        </div>
      </el-col>

      <!--tabs导航栏-->
      <el-col :span="9">
        <div class="grid_content">
          <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="beforeTabLeave">
            <el-tab-pane label="首页" name="homePage">
            </el-tab-pane>
            <el-tab-pane label="主营业务" name="mainBusiness">
            </el-tab-pane>
            <el-tab-pane label="客户案例" name="customerStories"></el-tab-pane>
            <el-tab-pane label="新闻中心" name="newsCenter"></el-tab-pane>
            <el-tab-pane label="培训中心" name="trainingCenter"></el-tab-pane>
            <el-tab-pane label="关于埃文" name="aboutAvi"></el-tab-pane>
<!--            <el-tab-pane label="旧版接入" name="fourth"></el-tab-pane>-->
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid_content"></div></el-col>
    </el-row>

    <el-row>
      <keep-alive>
        <component v-if='isChildUpdate1' :is='components.child0' style='padding-bottom: 20px'></component>
      </keep-alive>
      <keep-alive>
        <component v-if='isChildUpdate2' :is='components.child1' style='padding-bottom: 20px'></component>
      </keep-alive>
      <keep-alive>
        <component v-if='isChildUpdate3' :is='components.child5' style='padding-bottom: 20px'></component>
      </keep-alive>
      <keep-alive>
        <component v-if='isChildUpdate4' :is='components.child3' style='padding-bottom: 20px'></component>
      </keep-alive>
      <keep-alive>
        <component v-if='isChildUpdate5' :is='components.child2' style='padding-bottom: 20px'></component>
      </keep-alive>
      <keep-alive>
        <component v-if='isChildUpdate6' :is='components.child4' style='padding-bottom: 20px'></component>
      </keep-alive>
    </el-row>

    <!--插入尾部-->
    <div class="m-box" >
      <keep-alive>
        <component  :is='components.tail'></component>
      </keep-alive>
    </div>
  </div>
</template>

<script >
import homePage from './homePage.vue'
import mainBusiness from './mainBusiness.vue'
import trainingCenter from './trainingCenter.vue'
import newsCenter from './newsCenter.vue'
import customerStories from './customerStories.vue'
import aboutAvi from './aboutAvi.vue'
import platformPartners from './platformPartners.vue'
import footer from './footer.vue'
import expert from './expert.vue'
import { selectConfig } from '../../api/auth'
import FeedBack from './feedback.vue'

export default {
  provide () {
    return {
      say: this.say
    }
  },
  components: {
    FeedBack
  },
  created () {
    if (this.$route.query.type != null) {
      if (this.$route.query.type === '100') {
        this.say(this.$route.query.say)
      } else {
        this.sayDetailed(this.$route.query.type)
      }
    }
    this.webConfig()
    // this.selectProblem()
    this.$nextTick(function () {
      if (this.$route.query.type != null) {
        this.sayDetailed(this.$route.query.type)
      }
      // else if (this.$router.query.raw != null) {
      //   this.sayDetailed(this.$route.query.raw)
      // } else {
      //
      // }
    })
  },
  props: {
    srcList: {
    }
  },

  data () {
    return {
      input1: '',
      isDialog: true,
      activeName: 'homePage',
      isChildUpdate1: true,
      isChildUpdate2: false,
      isChildUpdate3: false,
      isChildUpdate4: false,
      isChildUpdate5: false,
      isChildUpdate6: false,
      isChildUpdate7: false,
      tableData: {
        legacyPortal: ''
      },
      queryParams: {
      },
      components: {
        child0: homePage,
        child1: mainBusiness,
        child2: trainingCenter,
        child3: newsCenter,
        child4: aboutAvi,
        child5: customerStories,
        child7: platformPartners,
        child8: expert,
        tail: footer
      }
    }
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL) // 这里有没有都无所谓，最好是有以防万一
      window.addEventListener('popstate', this.goBack, false) // 回退时执行goback方法
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    goBack () {
      window.location.reload()
    },
    skipHome (raw) {
      // if (window.location.href.indexOf('#reloaded') === -1) {
      //   window.location.href = window.location.href + '#reloaded'
      //   window.location.reload()
      // }
      this.$router.push({
        path: '/index'
      })
      window.location.reload()
    },
    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(this.queryParams).then(res => {
        that.tableData.legacyPortal = res.legacyPortal
      })
    },
    handleClick (tab, event) {
      if (tab.name === 'fourth') {
        window.open(this.tableData.legacyPortal, '_blank')
      } else if (tab.name === 'homePage') {
        this.skipHome()
        // this.isChildUpdate2 = false
        // this.isChildUpdate3 = false
        // this.isChildUpdate4 = false
        // this.isChildUpdate5 = false
        // this.isChildUpdate6 = false
        // this.isChildUpdate7 = false
        // this.isChildUpdate1 = true
        // this.isDialog = true
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/index',
          query: {
            type: 'mainBusiness'
          }
        })
        window.location.reload()
        // this.isChildUpdate2 = true
        // this.isChildUpdate3 = false
        // this.isChildUpdate4 = false
        // this.isChildUpdate5 = false
        // this.isChildUpdate6 = false
        // this.isDialog = false
        // this.isChildUpdate7 = false
        // this.isChildUpdate1 = false
      } else if (tab.name === 'customerStories') {
        this.$router.push({
          path: '/index',
          query: {
            type: 'customerStories'
          }
        })
        window.location.reload()
        // this.isChildUpdate2 = false
        // this.isChildUpdate3 = true
        // this.isChildUpdate4 = false
        // this.isChildUpdate5 = false
        // this.isChildUpdate6 = false
        // this.isChildUpdate7 = false
        // this.isChildUpdate1 = false
        // localStorage.setItem('customerStories', 'first')
        this.isDialog = false
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/index',
          query: {
            type: 'newsCenter'
          }
        })
        window.location.reload()
        // this.isChildUpdate2 = false
        // this.isChildUpdate3 = false
        // this.isChildUpdate4 = true
        // localStorage.setItem('newsCenter', 'journalism')
        //
        // this.isChildUpdate5 = false
        // this.isChildUpdate6 = false
        // this.isChildUpdate7 = false
        // this.isDialog = false
        // this.isChildUpdate1 = false
      } else if (tab.name === 'trainingCenter') {
        this.$router.push({
          path: '/index',
          query: {
            type: 'trainingCenter'
          }
        })
        window.location.reload()
        // this.isChildUpdate2 = false
        // this.isChildUpdate3 = false
        // this.isChildUpdate4 = false
        // this.isChildUpdate5 = true
        // this.isChildUpdate6 = false
        // this.isChildUpdate7 = false
        // this.isDialog = false
        // this.isChildUpdate1 = false
      } else if (tab.name === 'aboutAvi') {
        this.$router.push({
          path: '/index',
          query: {
            type: 'aboutAvi'
          }
        })
        window.location.reload()
        // this.isChildUpdate2 = false
        // this.isChildUpdate3 = false
        // this.isChildUpdate4 = false
        // this.isChildUpdate5 = false
        // this.isChildUpdate6 = true
        // this.isDialog = false
        // this.isChildUpdate7 = false
        // this.isChildUpdate1 = false
      }
    },
    // tabs切换拦截
    beforeTabLeave (newIndex, oldIndex) {
      if (newIndex === 'fourth') {
        return false
      } else {
        return true
      }
    },
    sayDetailed (raw) {
      if (raw === 'homePage') {
        this.isDialog = true
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = true
        this.activeName = 'homePage'
      } else if (raw === 'mainBusiness') {
        this.isDialog = false
        this.activeName = 'mainBusiness'
        localStorage.setItem('mainBusinessType', 'first')
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'customerStories') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.activeName = 'customerStories'
        this.isChildUpdate3 = true
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'newsCenter') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === 'trainingCenter') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.activeName = 'trainingCenter'
        this.isChildUpdate5 = true
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'aboutAvi') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.activeName = 'aboutAvi'
        this.isChildUpdate6 = true
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
      } else if (raw === 'journalism') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === 'industry') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'industry')
      } else if (raw === 'avi') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.activeName = 'newsCenter'
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'avi')
      } else if (raw === 'first') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.activeName = 'customerStories'
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('customerStories', 'first')
      } else if (raw === 'second') {
        this.isDialog = false
        this.isChildUpdate2 = false
        this.isChildUpdate3 = true
        this.activeName = 'customerStories'
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('customerStories', 'second')
      }
    },
    say (raw) {
      this.isDialog = false
      if (raw === '温室气体排放清单' || raw === '农林低碳发展' || raw === '政府发展规划' || raw === '生态文明建设' ||
        raw === '碳达峰时间预测和分析' || raw === '碳达峰碳中和科普与政策解读' || raw === '碳排放管理培训' || raw === '低碳试点建设' ||
        raw === '碳盘查' || raw === '节能与循环经济') {
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.activeName = 'mainBusiness'
        localStorage.setItem('mainBusinessType', 'first')
      } else if (raw === '企业碳管理咨询' || raw === '碳资产开发咨询' || raw === '绿色供应链标识服务' || raw === '环保咨询' ||
        raw === '碳达峰碳中和路径分析' || raw === '碳足迹咨询服务' || raw === '节能减排咨询' || raw === '绿色建筑评价报告' ||
        raw === '碳排放管理培训') {
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        this.activeName = 'mainBusiness'
        localStorage.setItem('mainBusinessType', 'second')
      } else if (raw === '碳排放智能监测与管控平台' || raw === '企业绿色低碳供应链标识服务') {
        this.activeName = 'mainBusiness'
        this.isChildUpdate2 = true
        this.isChildUpdate3 = false
        this.isChildUpdate4 = false
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('mainBusinessType', 'third')
      } else if (raw === '更多新闻') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'journalism')
      } else if (raw === '更多资讯') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'industry')
      } else if (raw === '更多观点') {
        this.activeName = 'newsCenter'
        this.isChildUpdate2 = false
        this.isChildUpdate3 = false
        this.isChildUpdate4 = true
        this.isChildUpdate5 = false
        this.isChildUpdate6 = false
        this.isChildUpdate7 = false
        this.isChildUpdate1 = false
        localStorage.setItem('newsCenter', 'avi')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}
.grid_content {
  height:100px;
  .logo{
    line-height: 100px;
    img{
      height: 40px;
      cursor:pointer;
    }
  }
}

//Tabs标签页
::v-deep .el-tabs__nav-scroll{
  width:100%;
  display: block;
  line-height: 100px;
  .el-tabs__nav{
    width: 100%;
    text-align: center;
    margin: 0 auto;
    z-index: 0;
  }
  .el-tabs__item{
    font-family: "MicrosoftYaHei";
    font-size: 16px;
    //font-weight: bold;
    color: #666;
  }
  .el-tabs__item:hover{
    color: #11a84e;
  }
  .el-tabs__item:focus{
    color: #11a84e;
  }
}
::v-deep .el-tabs__nav-wrap::after{
  color: #11a84e;
}
::v-deep .el-tabs__nav-scroll .el-tabs__item.is-active {
  color: #11a84e;
}
</style>
